import type { Commentary, CommentaryReply } from 'pages/Analysis/types';
import type { BasicSuccessResponse, HTTPFunctions } from '../types';

const comments = ({ get, post, put, del }: HTTPFunctions) => ({
  getComments: (documentId: string) => get<Commentary[]>(`comments/document/${documentId}`),
  updateComment: (id: number, comment: string) => put<Commentary>(`comments/${id}`, {comment}),
  delComment: (id: number) => del<BasicSuccessResponse>(`comments/${id}`),
  setCommentComplete: (id: number, resolved: boolean) => put<BasicSuccessResponse>(`comments/${id}`, {resolved}),
  addComment: (documentId: string, original: string, comment: string, position: number) => post<Commentary>('/comments/', { document_id: documentId, original, comment, position }),
  addReply: (id: number, reply: string) => post<CommentaryReply>('/replies/', { reply, comment_id: id }),
  updateReply: (id: number, reply: string) => put<BasicSuccessResponse>(`replies/${id}`, {reply}),
  delReply: (id: number) => del<BasicSuccessResponse>(`replies/${id}`)
});

export default comments;
